import { Component, OnInit,TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FundsTitleService } from 'src/app/Service/Funds/FundsTitle.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-FundsTitleList',
  templateUrl: './FundsTitleList.component.html',
  styleUrls: ['./FundsTitleList.component.scss']
})
export class FundsTitleListComponent implements OnInit {
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private Funds_Service:FundsTitleService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Funds:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1154).subscribe(
      data=>{
        this.ReadData_Funds()
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Funds(){
    this.Procssing=true
    this.Funds_Service.GetRecord().subscribe(
      data=>{
        this.DataList_Funds=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    this.Procssing=true
    this.modalRef_Delete.hide()
    this.Funds_Service.DeleteFundsTitle(item.id).subscribe(
      data => {
        this.Procssing=false
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("غیرفعال شد")
        else
          this.Alertify_Service.SuccessMessage("فعال شد")
        this.ReadData_Funds()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Minus(item:General_Interface){
    this.Procssing=true
    this.modalRef_Delete.hide()
    this.Funds_Service.MinusFundsTitle(item.id).subscribe(
      data => {
        this.Procssing=false
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("ثبت شد")
        else
          this.Alertify_Service.SuccessMessage("ثبت شد")
        this.ReadData_Funds()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  Switcher_Form: string = 'List'
  Set_Add_Switcher_Form() {
    this.Data_Seleted_Delete = Empty_General_Interface()
    this.Switcher_Form='Form'
  }

  Set_Edit_Switcher_Form(item:General_Interface) {
    this.Data_Seleted_Delete = item
    this.Switcher_Form='Form'
  }

  Set_Back_Switcher_Form() {
    this.Data_Seleted_Delete = Empty_General_Interface()
    this.Switcher_Form='List'
  }

}

